import type { ImageDimensions } from '@eliadmin/core/src/utils/image-dimensions';

// Original PNG IHDR dimensions verified 2026-10-16; exact API source URL keys.
export const BANNER_IMAGE_CONFIG: {
  dimensions: Readonly<Record<string, ImageDimensions>>;
} = {
  dimensions: {
    'https://api.najtrvalky.sk/files/banner-zxxhDgS6yW5LDhiLBECdJ8QL9BEkjh3ljHZkV75x.png?ai=0': {
      width: 2880,
      height: 1000,
    },
    'https://api.najtrvalky.sk/files/mobile-banner-oX2PteHDGkWTyTP6oICr9i0d21UE8lDYncFb8epK.png?ai=0':
      {
        width: 780,
        height: 1000,
      },
  },
};
